// extracted by mini-css-extract-plugin
module.exports = {"component":"style_component__jWbs4","loading-spinner":"style_loading-spinner__8N4Jx","view-more":"style_view-more__ltva_"};